import { inject, Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, QueryParamsHandling } from '@angular/router';
import { AuthService } from '../services/auth.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  private authService = inject(AuthService);

  constructor(
  ) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const queryParams = route.queryParams;
    this.getOriginDomain(queryParams);

    // Si el usuario intenta acceder a accounts.edutin.com pero tiene sesión activa redirige a la app correspondiente,  a menos que ingrese a:
    if (state.url !== '/update_account' && !state.url.includes('/logout') && this.authService.isAuthenticated()) {
      try {
        // Intenta refrescar el token antes de redirigir
        if (Object.keys(queryParams).length > 0) return true;
        this.authService.redirectToApp();// Redirigir a la app de destino
        return false;
      } catch (error) {
        console.error('Error al refrescar el token:', error);
        return true; // Si falla el refresh, permite la navegación a login
      }
    }

    return true;
  }


  /**
   *  getOriginDomain
   *  Obtiene el dominio de origen desde los query params y lo almacena en el servicio de autenticación.
   *  state = {
    *  source: 'app', // app || business || assist || designer || affiliate
        returnUrl: environment.appDomain,// https://app.edutin.com || https://business.edutin.com || https://assist.edutin.com || etc..
        nonce: random string para mayor seguridad
   * }
   * @param queryParams
   */
  getOriginDomain(queryParams: { [key: string]: string }): void {
    if (queryParams['state']) {
      const state = queryParams['state'];
      this.authService.originDomainData = state ? JSON.parse(atob(state)) : null;
    }
  }
}
